import { cardFuncEnumToViz } from "../../card-data/card-data-viz";

export default class CurrentCardElement {
  // perhaps the onclickhandler will destroy all the cards and set new ones? hah
  // would probably be better to get insert diff and add stuff in though...
  constructor(cardData, parentEl, onClickHandler) {
    this.cardData = cardData;

    this.domEl = document.createElement('button');
    this.domEl.classList.add('input-card');

    this.cardFuncViz = cardFuncEnumToViz[cardData.cardFuncContainer.cardFuncEnum];

    this.iconEl = document.createElement('span');
    this.iconEl.classList.add('material-symbols-rounded');
    this.iconEl.textContent = this.cardFuncViz.materialIconText;

    this.valueEl = document.createElement('span');
    this.valueEl.classList.add('int-val');

    this.valueEl.textContent = this.cardFuncViz.prependDebugStr === true
      ? `${this.cardFuncViz.debugFuncStr}${this.cardData.intVal}`
      : `${this.cardData.intVal}`;

    this.domEl.appendChild(this.iconEl);
    this.domEl.appendChild(this.valueEl);

    this.domEl.classList.add(this.cardFuncViz.cssClass);

    this.onClickHandler = onClickHandler;

    // could also be an event I guess?
    this.domEl.addEventListener('click', onClickHandler);

    parentEl.appendChild(this.domEl);
  }

  updateOnClickHandler(updatedOnClickHandler) {
    this.domEl.removeEventListener('click', this.onClickHandler);

    this.domEl.addEventListener('click', updatedOnClickHandler);

    this.onClickHandler = updatedOnClickHandler;
  }

  updateIntVal(intVal) {
    this.cardData.intVal = intVal;

    this.valueEl.textContent = this.cardFuncViz.prependDebugStr === true
      ? `${this.cardFuncViz.debugFuncStr}${this.cardData.intVal}`
      : `${this.cardData.intVal}`;
  }

  setUninteractable() {
    this.domEl.disabled = true;
  }

  // modify click handler? or modify card? instead of disposing
  // or perhaps clickHandler takes in a cardId?

  dispose() {
    this.domEl.removeEventListener('click', this.onClickHandler);

    this.domEl.remove();
  }
}